export default class Defines {
  /*
   * ベースSVGタグの名称
   */
  public static SVG_CONTAINER: string = '.svgContainer';

  /*
   * SVG内の定義タグの名称
   */
  public static SVG_DEFINE_CONTAINER: string = '.svgDefineContainer';

  /*
   * SVG内の表示タグのルート
   */
  public static SVG_ROOT_CONTAINER: string = '.svgRootContainer';

  /*
   * SVG内のアイテム要素のコンテナ
   */
  public static SVG_ITEM_CONTAINER: string = '.svgItemContainer';

  /*
   * SVG内のグリッド要素のコンテナ
   */
  public static SVG_GRID_LINES_CONTAINER: string = '.svgGridLinesContainer';

  /*
   * HTMLコンテナ
   */
  public static HTML_CONTAINER: string = '.overlayContainer';
}
